import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { CenteredLoader, Page, Section, Typography } from 'ui';

import { SiteMaterialUpdateForm } from '../../components/SiteMaterialUpdateForm/SiteMaterialUpdateForm';
import { useGetSiteMaterialDetails } from '../../hooks/useGetSiteMaterialDetails/useGetSiteMaterialDetails';

export const SiteMaterialUpdate = () => {
  const { t } = useTranslation('orders');
  const { id, data, isLoading } = useGetSiteMaterialDetails();

  if (isLoading) {
    return <CenteredLoader />;
  }

  return (
    <Page>
      <Page.BackButton
        component={Link}
        to={`/ground-control/v2/manage-company/${data?.site.trade_company.id}/site-materials`}
      >
        {t('siteMaterials.updatePage.actions.backToCompanySiteMaterials', {
          values: { companyName: data?.site.trade_company.name },
        })}
      </Page.BackButton>
      {!data ? (
        <Typography variant="h4" gutterBottom>
          {t('siteMaterials.updatePage.notFound')}
        </Typography>
      ) : (
        <Section title={t('siteMaterials.updatePage.sectionTitle')}>
          <SiteMaterialUpdateForm siteMaterialId={id} siteMaterialDetails={data} />
        </Section>
      )}
    </Page>
  );
};
